import { render, staticRenderFns } from "./productReport.vue?vue&type=template&id=79bb5055"
import script from "./productReport.js?vue&type=script&lang=js&external"
export * from "./productReport.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports